import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  Input,
  OnInit,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { interval } from 'rxjs';

@Component({
  selector: 'app-clock',
  templateUrl: './clock.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [DatePipe],
})
export class ClockComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  dateMode: string = 'EEE d MMM HH:mm';

  @Input() set showFullDate(value: boolean) {
    this.dateMode = value ? 'EEE d MMM HH:mm' : 'HH:mm';
  }

  currentTime = signal<Date>(new Date());

  ngOnInit(): void {
    this.startClock();
  }

  startClock(): void {
    interval(1000)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.currentTime.set(new Date()));
  }
}
